"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Lockr = __importStar(require("lockr"));
var navigation_1 = require("next/navigation");
var react_1 = require("react");
var storageKey = 'affiliate';
var TrackAffiliate = function () {
    var searchParams = (0, navigation_1.useSearchParams)();
    (0, react_1.useEffect)(function () {
        var partnerId = searchParams.get('partner_id');
        var offerId = searchParams.get('offer_id');
        var clickId = searchParams.get('click_id');
        var btag = searchParams.get('btag');
        if (btag) {
            var affPartsTrack360 = btag.split('_');
            partnerId = affPartsTrack360[0];
            offerId = affPartsTrack360[1];
            clickId = affPartsTrack360[2];
        }
        if (partnerId || offerId || clickId || btag)
            Lockr.set(storageKey, {
                date: new Date(),
                data: {
                    partnerId: partnerId,
                    offerId: offerId,
                    clickId: clickId,
                    type: btag ? 't360' : 'abase',
                },
            });
    }, [searchParams]);
    return null;
};
exports.default = TrackAffiliate;
